module.exports = __webpack_public_path__ + "static/media/Points_Cards.57d3ca00.png";